import IconButton from '@mui/material/IconButton'
import ITooltip from '../../ITooltip'
import { reExportedColors } from '../../index'
import AddIcon from '../../Icons/js/icons/AddIcon'

const AddIconButton = ({ className, onImportClick, onImportMode, disabled, size }) => (
  <div className={className}>
    <ITooltip placement='top' content='Add'>
      <IconButton
        disabled={disabled}
        onClick={onImportClick}
        sx={{
          backgroundColor: onImportMode ? reExportedColors.DARK_GREY : undefined,
          color: onImportMode ? reExportedColors.WHITE : undefined,
          padding: '6px',
          width: '36px',
          '&:hover': {
            backgroundColor: onImportMode ? reExportedColors.DARK_GREY : undefined
          }
        }}
      >
        <AddIcon fontSize={size || 'medium'} />
      </IconButton>
    </ITooltip>
  </div>
)

export default AddIconButton
